import { render } from "./BelgianWaffles.vue?vue&type=template&id=6c7d71e8&scoped=true"
import script from "./BelgianWaffles.vue?vue&type=script&lang=js"
export * from "./BelgianWaffles.vue?vue&type=script&lang=js"

import "./BelgianWaffles.vue?vue&type=style&index=0&id=6c7d71e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7d71e8"]])

export default __exports__